/** @flow */
import { takeLatest, put, call } from "redux-saga/effects";
import http from "@http";
import {
  GetReportingFocusListsEmployeeDefaultReports,
  GetReportingFocusListsEmployeeMyReports,
} from "@modules/reporting/constants/actions";
import actionCreator from "@modules/reporting/actionCreator";
import type { DefaultReports } from "@modules/reporting/reducer/focus-lists/employee/types";

type ReportDataResponse = DefaultReports;

function* onGetReportingFocusListsEmployeeDefaultReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/employee/default-reports`,
    );

    yield put(actionCreator.GetReportingFocusListsEmployeeDefaultReportsSuccess(response.data));
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsEmployeeDefaultReportsError({
        error: e.message,
      }),
    );
  }
}

function* onGetReportingFocusListsEmployeeMyReports(
  action,
): Generator<*, void, { data: ReportDataResponse }> {
  try {
    const { clientId } = action.payload;

    const response = yield call(
      http.get,
      `/api/v1/focus-lists/client/${clientId}/focus-lists/employee/my-saved-reports`,
    );

    yield put(actionCreator.GetReportingFocusListsEmployeeMyReportsSuccess(response.data));
    yield put(actionCreator.ReSetFocusListsEmployeeReportToSave());
  } catch (e) {
    yield put(
      actionCreator.GetReportingFocusListsEmployeeMyReportsError({
        error: e.message,
      }),
    );
  }
}

export default function* reportSaga(): Generator<*, void, void> {
  yield takeLatest(
    GetReportingFocusListsEmployeeMyReports,
    onGetReportingFocusListsEmployeeMyReports,
  );
  yield takeLatest(
    GetReportingFocusListsEmployeeDefaultReports,
    onGetReportingFocusListsEmployeeDefaultReports,
  );
}
